import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithAuthorizationCode, showErrorToast } from '../../helpers';
import { Spinner } from 'stm-frontend-library';
import { useAuth } from '../../components/Auth';

const getAuthorizationCode = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get('code');
};

export function AuthorizationCodeFlow() {
    const navigate = useNavigate();
    const { login } = useAuth();

    useEffect(() => {
        const handleAuth = async () => {
            const code = getAuthorizationCode();
            if (!code) {
                showErrorToast();
                return;
            }

            try {
                const response = await loginWithAuthorizationCode(code);
                if (response?.status === 200 && response.data?.token) {
                    await login(response);
                    navigate('/screened-manuscripts');
                }
            } catch (error) {
                navigate('/login');
                showErrorToast();
            }
        };

        handleAuth();
    }, [navigate, login]);

    return <Spinner />;
}
